<template>
  <section id="page" class="section" v-on:click="sectionClicked">
    <Header class="scrolled" ref="header"/>
    <div class="loadingLanguage" v-if="loadingLang"></div>
    <div class="articleDetail" v-else>
      <div class="cnt">
        <div class="bcnb">
          <div class="breadcrumb">
            <a href="/" class="bc">Home</a>
            <span class="dv">/</span>
            <a :href="`/${parentSlug}`" class="bc">
              {{lang.langs.website_name.value}}
            </a>
            <span class="dv">/</span>
            <span class="bc" v-if="detail">{{detail.title}}</span>
            <span v-else>. . .</span>
          </div>
        </div>
        <div class="loading" v-if="loading"></div>
        <div class="notFound" v-else-if="!detail">
          <img src="../assets/not-found.png">
          <h2>404 | {{lang.langs.not_found_title.value}}</h2>
        </div>
        <div class="detailCnt" v-else>
          <div class="detailL">
            <div class="detailLItem">
              <h2 v-if="langCode === 'id'">{{detail.title}}</h2>
              <h2 v-else-if="langCode === 'en'">{{detail.titleEn}}</h2>
              <div class="labels">
                <div class="label category" v-if="detail.categories
                  && detail.categories.length > 0">
                  <span v-if="detail.categories[0].parent">
                    <template v-if="langCode === 'id'">
                      {{detail.categories[0].parent.name}} /
                    </template>
                    <template v-else-if="langCode === 'en'">
                      {{detail.categories[0].parent.nameEn}} /
                    </template>
                  </span>
                  <template v-if="langCode === 'id'">
                    {{detail.categories[0].name}}
                  </template>
                  <template v-else-if="langCode === 'en'">
                    {{detail.categories[0].nameEn}}
                  </template>
                  <span v-if="detail.categories.length > 1">
                    + {{detail.categories.length - 1}} more
                  </span>
                </div>
                <div class="label status" v-if="detail.statusPutusan">
                  <template v-if="langCode === 'id'">
                    {{detail.statusPutusan.status}}
                  </template>
                  <template v-else-if="langCode === 'en'">
                    {{detail.statusPutusan.statusEn}}
                  </template>
                </div>
                <div class="label subjekHukum" v-if="detail.subjekHukum">
                  {{detail.subjekHukum.name}}
                </div>
                <div class="label location" v-if="detail.province">
                  {{detail.province.name}}
                </div>
              </div>
              <div class="dateCnt">
                <div class="theDate">
                  <div class="date">
                    <div class="dateLabel">{{lang.langs.reg_date_label.value}}</div>
                    <span v-if="detail.tanggalDaftar">:
                      {{detail.tanggalDaftar | moment('DD/MM/YYYY')}}</span>
                    <span v-else>: -</span>
                  </div>
                  <div class="date">
                    <div class="dateLabel">{{lang.langs.date_label.value}}</div>
                    <span v-if="detail.tanggalPutusan">:
                      {{detail.tanggalPutusan | moment('DD/MM/YYYY')}}</span>
                    <span v-else>: -</span>
                  </div>
                  <div class="date" v-if="detail.statusPerkara && detail.statusPerkara !== 'none'">
                    <div class="dateLabel">Status Perkara</div>
                    <span v-if="detail.statusPerkara === 'prepare_for_execution'">:
                      <template v-if="langCode === 'id'">Persiapan Eksekusi</template>
                      <template v-if="langCode === 'en'">Prepare for Execution</template>
                    </span>
                    <span v-if="detail.statusPerkara === 'request_for_execution'">:
                      <template v-if="langCode === 'id'">Permohonan Eksekusi</template>
                      <template v-if="langCode === 'en'">Request for Execution</template>
                    </span>
                    <span v-if="detail.statusPerkara === 'execution'">:
                      <template v-if="langCode === 'id'">Pelaksanaan Eksekusi</template>
                      <template v-if="langCode === 'en'">Execution</template>
                    </span>
                    <span v-if="detail.statusPerkara === 'execution_finished'">:
                      <template v-if="langCode === 'id'">Permohonan Eksekusi</template>
                      <template v-if="langCode === 'en'">Execution Finished</template>
                    </span>
                  </div>
                </div>
              </div>
              <div class="sinopsisCnt" :class="detail.sinopsisAlignment">
                <p v-if="langCode === 'id'">{{detail.sinopsis}}</p>
                <p v-else-if="langCode === 'en'">{{detail.sinopsisEn}}</p>
              </div>
              <template v-if="langCode === 'id'">
                <div class="tags" v-if="detail.tags && detail.tags.length > 0">
                  <div class="tag" v-for="(item, i) in detail.tags" :key="i"
                    v-on:click="tagClicked(item)">
                    {{item}}
                  </div>
                </div>
              </template>
              <template v-else-if="langCode === 'en'">
                <div class="tags" v-if="detail.tagsEn && detail.tagsEn.length > 0">
                  <div class="tag" v-for="(item, i) in detail.tagsEn" :key="i"
                    v-on:click="tagClicked(item)">
                    {{item}}
                  </div>
                </div>
              </template>
            </div>
            <div class="detailLItem">
              <template v-if="langCode === 'id'">
                <h3>{{lang.langs.detail_analysis.value}} {{detail.title}}</h3>
                <div v-if="detail.kasusPosisi">
                  <h4>{{lang.langs.detail_position_case.value}}</h4>
                  <div class="readContentItem" v-html="detail.kasusPosisi"></div>
                </div>
                <div v-if="detail.isuHukum">
                  <h4>{{lang.langs.detail_law_issue.value}}</h4>
                  <div class="readContentItem" v-html="detail.isuHukum"></div>
                </div>
                <div v-if="detail.analisisPutusan">
                  <h4>{{lang.langs.detail_verdict_analysis.value}}</h4>
                  <div v-if="detail.analisisPutusan.penemuanBaru">
                    <h5 class="h51">{{lang.langs.detail_new_discovery.value}}</h5>
                    <div class="readContentItem" v-html="detail.analisisPutusan.penemuanBaru"></div>
                  </div>
                  <div v-if="detail.analisisPutusan.menjawabPermasalahan">
                    <h5 class="h51">{{lang.langs.detail_responding_to_problems.value}}</h5>
                    <div class="readContentItem" v-html="detail.analisisPutusan.menjawabPermasalahan"></div>
                  </div>
                  <div v-if="detail.analisisPutusan.mengandungNilai">
                    <h5 class="h51">{{lang.langs.detail_contains_novelty.value}}</h5>
                    <div class="readContentItem" v-html="detail.analisisPutusan.mengandungNilai"></div>
                  </div>
                  <div v-if="detail.analisisPutusan.mencerminkan">
                    <h5>{{lang.langs.detail_reflecting.value}}</h5>
                    <div class="readContentItem" v-html="detail.analisisPutusan.mencerminkan"></div>
                  </div>
                  <div v-if="detail.analisisPutusan.perhatianBesar">
                    <h5>{{lang.langs.detail_attention.value}}</h5>
                    <div class="readContentItem"
                      v-html="detail.analisisPutusan.perhatianBesar"></div>
                  </div>
                </div>
                <div v-if="detail.keteranganTambahan">
                  <h5>{{lang.langs.detail_additional_information.value}}</h5>
                  <div class="readContentItem" v-html="detail.keteranganTambahan"></div>
                </div>
              </template>
              <template v-else-if="langCode === 'en'">
                <h3>{{lang.langs.detail_analysis.value}} {{detail.titleEn}}</h3>
                <div v-if="detail.kasusPosisiEn">
                  <h4>{{lang.langs.detail_position_case.value}}</h4>
                  <div class="readContentItem" v-html="detail.kasusPosisiEn"></div>
                </div>
                <div v-if="detail.isuHukumEn">
                  <h4>{{lang.langs.detail_law_issue.value}}</h4>
                  <div class="readContentItem" v-html="detail.isuHukumEn"></div>
                </div>
                <div v-if="detail.analisisPutusan">
                  <h4>{{lang.langs.detail_verdict_analysis.value}}</h4>
                  <div v-if="detail.analisisPutusan.penemuanBaruEn">
                    <h5 class="h51">{{lang.langs.detail_new_discovery.value}}</h5>
                    <div class="readContentItem"
                      v-html="detail.analisisPutusan.penemuanBaruEn"></div>
                  </div>
                  <div v-if="detail.analisisPutusan.menjawabPermasalahanEn">
                    <h5 class="h51">{{lang.langs.detail_responding_to_problems.value}}</h5>
                    <div class="readContentItem" v-html="detail.analisisPutusan.menjawabPermasalahanEn"></div>
                  </div>
                  <div v-if="detail.analisisPutusan.mengandungNilaiEn">
                    <h5 class="h51">{{lang.langs.detail_contains_novelty.value}}</h5>
                    <div class="readContentItem" v-html="detail.analisisPutusan.mengandungNilaiEn"></div>
                  </div>
                  <div v-if="detail.analisisPutusan.mencerminkanEn">
                    <h5>{{lang.langs.detail_reflecting.value}}</h5>
                    <div class="readContentItem"
                      v-html="detail.analisisPutusan.mencerminkanEn"></div>
                  </div>
                  <div v-if="detail.analisisPutusan.perhatianBesarEn">
                    <h5>{{lang.langs.detail_attention.value}}</h5>
                    <div class="readContentItem"
                      v-html="detail.analisisPutusan.perhatianBesarEn"></div>
                  </div>
                </div>
                <div v-if="detail.keteranganTambahanEn">
                  <h5>{{lang.langs.detail_additional_information.value}}</h5>
                  <div class="readContentItem" v-html="detail.keteranganTambahanEn"></div>
                </div>
              </template>
              <div class="lastUpdated" v-if="detail.lastEdited">
                <template v-if="langCode === 'id'">Terakhir diperbarui:</template>
                <template v-if="langCode === 'en'">Latest update:</template>
                {{detail.lastEdited | moment('D MMM YYYY')}}
              </div>
            </div>
            <div class="detailLItem detailAhli" v-if="detail.tanggapanAhli
              && detail.tanggapanAhli.length > 0">
              <h3>{{lang.langs.detail_expert_feedback.value}}</h3>
              <div class="wlPaging">
                <div class="wlPagingItem left" v-if="ahliPos > 0"
                  v-on:click="ahliPos -= (ahliPos > 0) ? 1 : 0"></div>
                <div class="wlPagingItem right" v-if="ahliPos < detail.tanggapanAhli.length - 1"
                  v-on:click="ahliPos += (ahliPos < detail.tanggapanAhli.length - 1) ? 1 : 0"></div>
              </div>
              <div class="ahliSliderCnt">
                <div class="ahliSlider">
                  <div class="ahliSc" :class="ahliPosClass"
                    :style="{width: `${detail.tanggapanAhli.length}00%`}">
                    <div class="ahliItem" v-for="(item, i) in detail.tanggapanAhli" :key="i"
                      :style="{width: `calc(100% / ${detail.tanggapanAhli.length})`}">
                      <div class="readContentItem tanggapanAhli">
                        <div class="quote">“</div>
                        <div class="tanggapanAhliContent" :class="item.alignment">
                          <p v-if="langCode === 'id'">{{item.tanggapan}}</p>
                          <p v-else-if="langCode === 'en'">{{item.tanggapanEn}}</p>
                        </div>
                      </div>
                      <div class="ahli">
                        <div class="ahliPict" v-if="item.fotoAhli"
                          :style="{'background-image': `url(${item.fotoAhli.imageTh})`}"></div>
                        <div class="ahliPict noImg" v-else></div>
                        <h4><a :href="`/ahli/${item.namaAhli}`">{{item.namaAhli}}</a></h4>
                        <p>{{item.gelarAhli}}</p>
                        <template v-if="langCode === 'id' && item.attachments
                          && item.attachments.length > 0">
                          <div v-on:click="openForm('Expert Review', item,
                            item.attachments[0].media, item.attachments[0].media.uri)"
                            class="download" v-if="item.attachments.length === 1"></div>
                          <div class="download" v-on:click="openDlSelector(item)"
                            v-else-if="item.attachments.length > 1"></div>
                        </template>
                        <template v-if="langCode === 'en' && item.attachmentsEn
                          && item.attachmentsEn.length > 0">
                          <div v-on:click="openForm('Expert Review', item,
                            item.attachmentsEn[0].media, item.attachmentsEn[0].media.uri)"
                            class="download" v-if="item.attachmentsEn.length === 1"></div>
                          <div class="download" v-on:click="openDlSelector(item)"
                            v-else-if="item.attachmentsEn.length > 1"></div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wlPager">
                <div class="pItem" v-for="(item, i) in detail.tanggapanAhli" :key="i"
                  :class="{active: ahliPos === i}"
                  v-on:click="ahliPos = i"></div>
              </div>
            </div>
          </div>
          <div class="detailR">
            <div class="detailRItem" v-if="detail.putusan && detail.putusan.length > 0">
              <h4>{{lang.langs.verdict_list.value}}</h4>
              <div v-for="(item, i) in detail.putusan" :key="i">
                <template v-if="langCode === 'id'">
                  <div v-on:click="openForm(item.typeData.name, item,
                    item.attachments[0].media, item.attachments[0].media.uri)"
                    class="putusanItem" v-if="item.attachments
                    && item.attachments.length > 0">
                    <div class="type" v-if="item.typeData">{{item.typeData.name}}:</div>
                    <div class="putusanNo">{{item.nomorPutusan}}</div>
                  </div>
                  <a href="#"
                    class="putusanItem noDownload" v-else>
                    <div class="type" v-if="item.typeData">{{item.typeData.name}}:</div>
                    <div class="putusanNo">{{item.nomorPutusan}}</div>
                  </a>
                </template>
                <template v-else-if="langCode === 'en'">
                  <div v-on:click="openForm(item.typeData.nameEn, item,
                    item.attachmentsEn[0].media, item.attachmentsEn[0].media.uri)"
                    class="putusanItem" v-if="item.attachmentsEn
                    && item.attachmentsEn.length > 0">
                    <div class="type" v-if="item.typeData">{{item.typeData.nameEn}}:</div>
                    <div class="putusanNo">{{item.nomorPutusan}}</div>
                  </div>
                  <a href="#"
                    class="putusanItem noDownload" v-else>
                    <div class="type" v-if="item.typeData">{{item.typeData.nameEn}}:</div>
                    <div class="putusanNo">{{item.nomorPutusan}}</div>
                  </a>
                </template>
              </div>
            </div>
            <div class="detailRItem">
              <div class="tabCnt">
                <div class="tab" :class="{selected: quotaTab === 'analisisPutusan'}"
                  v-on:click="quotaTab = 'analisisPutusan'">
                  {{lang.langs.quote_label.value}}
                </div>
                <div class="tab" :class="{selected: quotaTab === 'tanggapanAhli'}"
                  v-on:click="quotaTab = 'tanggapanAhli'">
                  Kutip Tanggapan Ahli
                </div>
              </div>
              <template v-if="quotaTab === 'analisisPutusan'">
                <h4>{{lang.langs.quote_label.value}}</h4>
                <div class="quotes">
                  <div class="qt" v-on:click="setQuote('apa')">
                    <b>APA</b></div>
                  <div class="qt" v-on:click="setQuote('bluebook')">
                    <b>Bluebook</b></div>
                  <div class="qt" v-on:click="setQuote('chicago')">
                    <b>Chicago</b></div>
                  <div class="qt" v-on:click="setQuote('mla')">
                    <b>MLA</b></div>
                </div>
                <p class="footnote" v-html="quote"></p>
                <div class="copy" v-on:click="copyQuote">
                  {{lang.langs.copy_label.value}}
                </div>
              </template>
              <template v-if="quotaTab === 'tanggapanAhli'">
                <h4>Kutip Tanggapan Ahli</h4>
                <div class="quotes">
                  <div class="qt" v-on:click="setQuote('apa')">
                    <b>APA</b></div>
                  <div class="qt" v-on:click="setQuote('bluebook')">
                    <b>Bluebook</b></div>
                  <div class="qt" v-on:click="setQuote('chicago')">
                    <b>Chicago</b></div>
                  <div class="qt" v-on:click="setQuote('mla')">
                    <b>MLA</b></div>
                </div>
                <p class="footnote" v-html="quote"></p>
                <div class="copy" v-on:click="copyQuoteAhli">
                  {{lang.langs.copy_label.value}}
                </div>
              </template>
            </div>
            <div class="detailRItem" v-if="detail.namaPengadilan">
              <h4>Pengadilan yang Memutuskan</h4>
              <p>{{detail.namaPengadilan}}</p>
            </div>
            <div class="detailRItem" v-if="detail.namaHakim && detail.namaHakim.length > 0">
              <h4>Majelis Hakim Perkara</h4>
              <ol class="hakimOl">
                <li class="hakimItem" v-for="(nh, i) in detail.namaHakim" :key="`nh${i}`">
                  {{nh.name}}
                  <span v-if="nh.type && nh.type !== 'none'"> -
                    <template v-if="nh.type === 'chief_judge'">
                      <template v-if="langCode === 'id'">Hakim Ketua</template>
                      <template v-if="langCode === 'en'">Chief Judge</template>
                    </template>
                    <template v-if="nh.type === 'member_judge'">
                      <template v-if="langCode === 'id'">Hakim Anggota</template>
                      <template v-if="langCode === 'en'">Member Judge</template>
                    </template>
                  </span>
                </li>
              </ol>
            </div>
            <div class="detailRItem" v-if="related.length > 0">
              <h4>Putusan Terkait</h4>
              <a :href="`/portal-putusan-icel/${item.slug}`"
                class="relatedItem" v-for="(item, i) in related" :key="`rld${i}`">
                <div class="index">#{{i + 1}}</div>
                <div class="relatedTitle">
                  {{item.title}}
                </div>
              </a>
            </div>
            <div class="detailRItem" v-if="related.length > 0">
              <h4 v-if="langCode === 'id'">Bagikan</h4>
              <h4 v-if="langCode === 'en'">Share</h4>
              <div class="articleShare articleShareStatic">
                <div class="shareCnt">
                  <a target="_balnk"
                    :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
                    <i class="fa fa-facebook fa-fw"></i>
                  </a>
                  <a target="_balnk"
                    :href="`https://twitter.com/intent/tweet?text=${detail.title}&amp;url=${shareUri}`">
                    <i class="fa fa-twitter fa-fw"></i>
                  </a>
                  <a :href="`whatsapp://send?text=${detail.title} ${shareUri}`">
                    <i class="fa fa-whatsapp fa-fw"></i>
                  </a>
                  <a target="_balnk"
                    :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${detail.title}`">
                    <i class="fa fa-telegram fa-fw"></i>
                  </a>
                  <a :href="`mailto:?subject=${detail.title}&amp;body=Check this out:
                    <a href='${shareUri}'>${detail.title}</a>`">
                    <i class="fa fa-email fa-fw"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
    <ShareDialog ref="shareDialog"/>
    <EmbedDialog ref="embedDialog"/>
    <Snackbar ref="snackbar"/>
    <DownloadSelector ref="downloadSelector"/>
    <FormDialog ref="formDialog"/>
  </section>
</template>

<script>
import moment from 'moment';
import Header from '@/components/Header.vue';
import ShareDialog from '@/components/ShareDialog.vue';
import EmbedDialog from '@/components/EmbedDialog.vue';
import Snackbar from '@/components/Snackbar.vue';
import DownloadSelector from '@/components/DownloadSelector.vue';
import Footer from '@/components/Footer.vue';
import FormDialog from '@/components/FormDialog.vue';

export default {
  name: 'read',
  components: {
    Header,
    ShareDialog,
    EmbedDialog,
    Snackbar,
    DownloadSelector,
    Footer,
    FormDialog,
  },
  data() {
    return {
      loading: true,
      detail: null,
      qrString: null,
      loadingQr: true,
      qrError: false,
      sessionId: '',
      currentPage: 1,
      inPage: true,
      singingAl: true,
      uuid: '',
      pwd: '',
      parentSlug: '',
      quote: '',
      related: [],
      shareUri: '',
      quotaTab: 'analisisPutusan',

      /**
       * Tanggapan ahli
       *
       */
      ahliPos: 0,

      /**
       * Language
       *
       */
      loadingLang: true,
      langCode: 'id',
      lang: null,
    };
  },
  computed: {
    ahliPosClass() {
      return `pos${this.ahliPos}`;
    },
  },
  methods: {
    sectionClicked() {
      this.showSortOptions = false;
      this.$refs.header.sectionClicked();
    },
    tagClicked(tag) {
      const tagEncoded = encodeURI(tag.replaceAll('#', ''));
      window.location.href = `/${this.parentSlug}?hashtags=${tagEncoded}`;
    },
    openDlSelector(ta) {
      const att = (this.langCode === 'id') ? ta.attachments : ta.attachmentsEn;
      this.$refs.downloadSelector.open(att, (b, media, url) => {
        if (!b) return;
        this.openForm('Expert Review', ta, media, url);
      });
    },
    openForm(type, item, media, url) {
      this.$refs.formDialog.open({
        detail: this.detail,
        type,
        item,
        media,
      }, (b) => {
        if (!b) return;
        window.open(url, '_blank').focus();
      });
    },
    setQuote(type) {
      if (!this.detail) return;
      const mNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'December',
      ];
      const d = new Date();
      const dd = (d.getDate() < 10) ? `0${d.getDate()}` : `${d.getDate()}`;
      const uri = `${this.$config.appUri}${this.parentSlug}/${this.detail.slug}`;
      if (type === 'apa') {
        this.quote = `${this.detail.title} (n.d.). `
          + '<i>Portal Putusan Penting by Indonesian Center for Environmental Law</i>.'
          + ` Retrieved ${mNames[d.getMonth()]} ${dd} ${d.getFullYear()}, `
          + `from ${uri}`;
      } else if (type === 'bluebook') {
        this.quote = `${this.detail.title}, Portal Putusan Penting by Indonesian Center`
          + ` for Environmental Law, ${uri} (last visited `
          + `${mNames[d.getMonth()].substr(0, 3)} ${dd}, ${d.getFullYear()}).`;
      } else if (type === 'chicago') {
        this.quote = `“${this.detail.title}”. Portal Putusan Penting by Indonesian `
          + 'Center for Environmental Law. Accessed '
          + `${mNames[d.getMonth()]} ${dd} ${d.getFullYear()}. ${uri}.`;
      } else if (type === 'mla') {
        this.quote = `“${this.detail.title}”. <i>Portal Putusan Penting by `
          + 'Indonesian Center for Environmental Law</i>, '
          + `${uri}. Accessed ${dd} ${mNames[d.getMonth()].substr(0, 3)}. ${d.getFullYear()}}.`;
      }
    },
    share() {
      this.$refs.shareDialog.open(this.detail, {
        page: this.currentPage,
        session: this.sessionId,
      });
    },
    download() {
      const alUri = `content/${this.detail.id}/download?session=${this.sessionId}&page=${this.currentPage}`;
      this.$http.get(this.$config.uri(alUri)).then(() => {});
    },
    copyQuote() {
      const m = document;
      const txt = m.createTextNode(this.quote);
      const w = window;
      const b = m.body;
      b.appendChild(txt);
      if (b.createTextRange) {
        const d = b.createTextRange();
        d.moveToElementText(txt);
        d.select();
        m.execCommand('copy');
      } else {
        const d = m.createRange();
        const g = w.getSelection;
        d.selectNodeContents(txt);
        g().removeAllRanges();
        g().addRange(d);
        m.execCommand('copy');
        g().removeAllRanges();
      }
      txt.remove();
      this.$refs.snackbar.open({ content: 'Quote copied to clipboard.' });
    },
    copyQuoteAhli() {
      /**
       * Need to check and validate
       * Copy text should be
       * (nama ahli), “Judul Analisis”, I-LEAD, (tahun tanggapan ahli dibuat). Diakses pada (tgl kapan pengunjung akses), (langsung link website yg diakses pengunjung aja)
       */
      if (!this.detail.tanggapanAhli || this.detail.tanggapanAhli.length < 1) return;
      const name = `${this.detail.tanggapanAhli[0].namaAhli} ${this.detail.tanggapanAhli[0].gelarAhli}`;
      const title = this.langCode === 'id' ? this.detail.title : this.detail.titleEn;
      const year = this.detail.publishYear;
      const currentDate = moment().format('DD/MM/YYYY');
      const uri = `https://i-lead.icel.or.id${this.$route.fullPath}`;
      const accessedAt = this.langCode === 'id' ? 'Diakses pada' : 'Accessed at';
      const text2Copy = `${name}, "${title}", I-LEAD, ${year}.  ${accessedAt} ${currentDate}, ${uri}`;

      /**
       * Copy the text
       */
      const m = document;
      const txt = m.createTextNode(text2Copy);
      const w = window;
      const b = m.body;
      b.appendChild(txt);
      if (b.createTextRange) {
        const d = b.createTextRange();
        d.moveToElementText(txt);
        d.select();
        m.execCommand('copy');
      } else {
        const d = m.createRange();
        const g = w.getSelection;
        d.selectNodeContents(txt);
        g().removeAllRanges();
        g().addRange(d);
        m.execCommand('copy');
        g().removeAllRanges();
      }
      txt.remove();
      this.$refs.snackbar.open({ content: 'Quote copied to clipboard.' });
    },
    getRelated() {
      this.$http.get(this.$config.uri(`content/${this.detail.id}/related`)).then((r) => {
        this.related = r.data.status === 200 ? r.data.data : [];
      });
    },
    getData() {
      this.loading = true;
      const key = (this.$route.query.key) ? `&key=${this.$route.query.key}` : '';
      const detailUri = `content/${this.$route.params.slug}?session=${this.sessionId}${key}`
        + `&pkey=${this.$route.query.pkey}&pwd=${this.pwd}`;
      this.$http.get(this.$config.uri(detailUri)).then((r) => {
        this.detail = (r.data.status === 200) ? r.data.data : null;
        this.setQuote('apa');
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        document.title = (r.data.status === 200)
          ? `${this.detail.title} - ${this.$config.appName}`
          : `Content Not Found - ${this.$config.appName}`;
        this.loading = false;
        this.sessionId = r.data.session;
        sessionStorage.setItem('sessionId', this.sessionId);
        this.shareUri = `${this.$config.appUri}portal-putusan-icel/${this.detail.slug}`;

        this.getRelated();
        // const relatedUri = `content/all?parentId=${this.detail.category.id}&related=${this.detail.id}&limit=5`;
        // this.$http.get(this.$config.uri(relatedUri)).then((rr) => {
        //   this.related = (rr.data.status === 200) ? rr.data.data : null;
        //   this.loading = false;
        // });
      });
    },
    signAnalytic() {
      if (!this.inPage) {
        this.singingAl = false;
        return;
      }
      this.singingAl = true;
      const alUri = `content/${this.detail.id}/al?session=${this.sessionId}`
        + `&page=${this.currentPage}&uuid=${this.uuid}`;
      this.$http.post(this.$config.uri(alUri), {
        city: this.city,
        country: this.country,
      }).then((r) => {
        setTimeout(() => {
          this.singingAl = false;
          this.signAnalytic();
        }, 5000);
      });
    },
    windowFocused() {
      this.inPage = true;
      if (!this.singingAl) this.signAnalytic();
    },
    windowBlured() {
      this.inPage = false;
    },
  },
  created() {
    window.addEventListener('focus', this.windowFocused);
    window.addEventListener('blur', this.windowBlured);
  },
  destroyed() {
    window.removeEventListener('focus', this.windowFocused);
    window.removeEventListener('blur', this.windowBlured);
  },
  beforeDestroy() {
    this.inPage = false;
  },
  mounted() {
    this.langCode = localStorage.getItem('portal_putusan_penting_icel_lang') || 'id';
    // if (!this.langCode) this.langCode = window.navigator.userLanguage || window.navigator.language;
    // if (this.langCode === 'en-US' || this.langCode === 'en') this.langCode = 'en';
    // else if (this.langCode === 'id-ID' || this.langCode === 'id') this.langCode = 'id';
    // else this.langCode = 'en';

    this.$http.get(this.$config.uri(`misc/lang/${this.langCode}`)).then((rlang) => {
      this.loadingLang = false;
      this.lang = rlang.data.data;
      this.parentSlug = this.$route.params.parent;
      this.getData();
    });
  },
};
</script>

<style lang="scss">
.bcnb{
  margin: 0;
  // font-family: 'Source Serif Pro', serif;
}
.articleDetail{
  padding: 60px 0 40px;
  // font-family: 'Source Serif Pro', serif;
  box-sizing: border-box;
  min-height: 100vh;
  position: relative;
  .loading{
    position: absolute;
    left: 0; top: 60px; right: 0; bottom: 0;
    background-image: url(../assets/loading.svg);
    background-size: 46px auto;
    background-position: center;
    background-repeat: no-repeat;
  }
  .notFound{
    position: absolute;
    left: 50%; top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #767676;
    // font-family: 'Source Serif Pro', serif;
    img{
      width: 600px;
      margin: 0 0 40px;
      display: none;
    }
    h4{
      margin: 0;
      font-size: 34px;
    }
    h2{
      margin: 0;
      font-size: 20px;
    }
  }
  .detailCnt{
    display: flex;
    @media (max-width: 960px) {
      display: block;
    }
    .detailL{
      width: calc(100% - 400px);
      box-sizing: border-box;
      @media (max-width: 960px) {
        width: auto;
        margin-bottom: 40px;
      }
      .detailLItem{
        padding: 20px;
        padding-bottom: 4px;
        border: #eee 1px solid;
        border-radius: 10px;
        margin: 0 0 20px;
        font-size: 18px;
        @media (max-width: 680px) {
          font-size: 16px;
          padding: 20px 16px;
        }
        h2{
          margin: 0 0 16px;
          font-size: 32px;
          font-weight: 600;
          @media (max-width: 680px) {
            font-size: 26px;
            margin-bottom: 10px;
          }
        }
        p{
          margin: 0 0 16px;
          line-height: 1.4;
          font-size: inherit !important;
          @media (max-width: 680px) {
            margin-bottom: 10px;
          }
        }
        ol{
          margin: 0 0 16px;
          @media (max-width: 680px) {
            margin-bottom: 10px;
          }
          li{
           font-size: inherit !important;
          }
        }
        ul{
          margin: 0 0 16px;
          @media (max-width: 680px) {
            margin-bottom: 10px;
          }
          li{
            font-size: inherit !important;
          }
        }
        h3{
          font-size: 24px;
          margin: 0 0 10px;
          font-weight: 600;
          @media (max-width: 680px) {
            font-size: 22px;
          }
        }
        h4{
          font-size: 22px;
          margin: 40px 0 10px;
          font-weight: 600;
          @media (max-width: 680px) {
            font-size: 20px;
          }
        }
        h5{
          font-size: 19px;
          margin: 40px 0 10px;
          font-weight: 600;
          @media (max-width: 680px) {
            font-size: 18px;
          }
          &.h51{
            margin-top: 20px;
          }
        }
        .lastUpdated{
          font-size: 14px;
          margin: 0 0 16px;
        }
        .labels{
          display: flex;
          flex-wrap: wrap;
          padding: 0 0 6px;
          .label{
            padding: 6px 10px;
            font-size: 14px;
            margin: 0 10px 10px 0;
            background-color: #222;
            color: #fff;
            border-radius: 3px;
            // font-family: 'Inter', sans-serif;
            &.category{
              background-color: #212E71;
            }
            &.status{
              background-color: #115457;
            }
            &.subjekHukum{
              background-color: #571010;
              display: none;
            }
            @media (max-width: 680px) {
              font-size: 12px;
              margin: 0 5px 10px 0;
            }
          }
        }
        .sinopsisCnt{
          &.left{
            text-align: left;
          }
          &.right{
            text-align: right;
          }
          &.center{
            text-align: center;
          }
          &.justify{
            text-align: justify;
          }
        }
        .tags{
          display: flex;
          flex-wrap: wrap;
          margin: 0 0 12px;
          @media (max-width: 680px) {
            margin-bottom: 6px;
          }
          .tag{
            cursor: pointer;
            margin: 0 14px 4px 0;
            color: #115457;
            transition: all .3s ease;
            line-height: 1.4;
            font-weight: 400;
            font-size: 18px;
            @media (max-width: 680px) {
              font-size: 16px;
              margin-bottom: 2px;
            }
            &:hover{
              color: #369d66;
            }
          }
        }
        .dateCnt{
          margin-bottom: 12px;
          @media (max-width: 680px) {
            margin-bottom: 6px;
          }
          .date{
            display: flex;
            width: 100%;
            padding: 0 0 4px;
            line-height: 1.4;
            font-size: 18px;
            @media (max-width: 680px) {
              font-size: 16px;
            }
            .dateLabel{
              width: 160px;
            }
          }
        }
        .tanggapanAhliContent{
          &.left{
            text-align: left;
          }
          &.right{
            text-align: right;
          }
          &.center{
            text-align: center;
          }
          &.justify{
            text-align: justify;
          }
        }
        .readContentItem.tanggapanAhli{
          position: relative;
          padding-left: 50px;
          padding-right: 20px;
          @media (max-width: 680px) {
            padding-left: 30px;
          }
          p{
            @media (max-width: 680px) {
              font-size: 15px;
              line-height: 1.2;
            }
          }
          .quote{
            font-size: 94px;
            color: #558788;
            opacity: .35;
            position: absolute;
            left: 0; top: -16px;
            @media (max-width: 680px) {
              left: -6px;
              font-size: 76px;
            }
          }
        }
        &.detailAhli{
          position: relative;
          .wlPaging{
            position: absolute;
            left: -18px; right: -18px; top: 50%;
            transform: translateY(-50%);
            display: flex;
            z-index: 9;
            justify-content: space-between;
            @media (max-width: 680px) {
              left: -14px; right: -14px;
            }
            .wlPagingItem{
              background-color: #115457;
              width: 36px; height: 36px;
              border-radius: 50%;
              cursor: pointer;
              background-size: 16px auto;
              background-position: center;
              background-repeat: no-repeat;
              transition: all .3s ease;
              &:hover{
                box-shadow: 0 0 4px rgba(0, 0, 0, .1);
                background-color: #369d66;
              }
              &.left{
                margin-right: auto;
                background-image: url(../assets/arrow-left-white.png);
              }
              &.right{
                margin-left: auto;
                background-image: url(../assets/arrow-right-white.png);
              }
            }
          }
          .wlPager{
            position: absolute;
            bottom: -16px; right: 5px;
            display: flex;
            margin-right: auto;
            .pItem{
              width: 8px; height: 8px;
              background-color: #ccc;
              margin-right: 4px;
              border-radius: 50%;
              transition: all .3s ease;
              cursor: pointer;
              &:hover{
                background-color: #999;
              }
              &.active{
                background-color: #558788;
              }
            }
          }
        }
        .ahliSliderCnt{
          margin: 0 -20px;
          position: relative;
          .ahliSlider{
            overflow: hidden;
            width: 100%;
            box-sizing: border-box;
            .ahliSc{
              display: flex;
              box-sizing: border-box;
              transition: all .3s ease;
              &.pos1{ margin-left: -100%; }
              &.pos2{ margin-left: -200%; }
              &.pos3{ margin-left: -300%; }
              &.pos4{ margin-left: -400%; }
              &.pos5{ margin-left: -500%; }
              &.pos6{ margin-left: -600%; }
              &.pos7{ margin-left: -700%; }
              &.pos8{ margin-left: -800%; }
              &.pos9{ margin-left: -900%; }
              &.pos10{ margin-left: -1000%; }
              &.pos11{ margin-left: -1100%; }
              &.pos12{ margin-left: -1200%; }
              &.pos13{ margin-left: -1300%; }
              &.pos14{ margin-left: -1400%; }
              &.pos15{ margin-left: -1500%; }
              &.pos16{ margin-left: -1600%; }
              &.pos17{ margin-left: -1700%; }
              &.pos18{ margin-left: -1800%; }
              &.pos19{ margin-left: -1900%; }
              &.pos20{ margin-left: -2000%; }
              &.pos21{ margin-left: -2100%; }
              &.pos22{ margin-left: -2200%; }
              &.pos23{ margin-left: -2300%; }
              &.pos24{ margin-left: -2400%; }
              &.pos25{ margin-left: -2500%; }
              &.pos26{ margin-left: -2600%; }
              &.pos27{ margin-left: -2700%; }
              &.pos28{ margin-left: -2800%; }
              &.pos29{ margin-left: -2900%; }
              &.pos30{ margin-left: -3000%; }
              &.pos31{ margin-left: -3100%; }
              &.pos32{ margin-left: -3200%; }
              &.pos33{ margin-left: -3300%; }
              &.pos34{ margin-left: -3400%; }
              &.pos35{ margin-left: -3500%; }
              &.pos36{ margin-left: -3600%; }
              &.pos37{ margin-left: -3700%; }
              &.pos38{ margin-left: -3800%; }
              &.pos39{ margin-left: -3900%; }
              &.pos40{ margin-left: -4000%; }
              &.pos41{ margin-left: -4100%; }
              &.pos42{ margin-left: -4200%; }
              &.pos43{ margin-left: -4300%; }
              &.pos44{ margin-left: -4400%; }
              &.pos45{ margin-left: -4500%; }
              &.pos46{ margin-left: -4600%; }
              &.pos48{ margin-left: -4800%; }
              &.pos49{ margin-left: -4900%; }
              &.pos50{ margin-left: -5000%; }
              .ahliItem{
                box-sizing: border-box;
                padding: 0 20px;
                display: flex;
                flex-direction: column;
              }
            }
          }
        }
        .ahli{
          position: relative;
          padding: 6px 40px 22px 74px;
          margin-top: auto;
          .ahliPict{
            width: 60px; height: 60px;
            background-color: #eee;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            border-radius: 50%;
            position: absolute;
            left: 0; top: 0;
            &.noImg{
              &:before{
                position: absolute;
                content: "";;
                left: 0; top: 0; right: 0; bottom: 0;
                background-image: url(../assets/image-black.png);
                background-position: center;
                background-size: 26px auto;
                background-repeat: no-repeat;
                opacity: .3;
              }
            }
          }
          h4{
            margin: 0;
            font-size: 20px;
            @media (max-width: 680px) {
              font-size: 17px;
            }
          }
          p{
            margin: 0;
            font-size: 15px;
          }
          .download{
            cursor: pointer;
            display: block;
            width: 36px; height: 36px;
            position: absolute;
            right: 0; top: 16px;
            border-radius: 50%;
            background-image: url(../assets/download-icon.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
            transition: all .3s ease;
            cursor: pointer;
            &:hover{
              background-color: #f5f5fe;
            }
          }
        }
      }
    }
    .detailR{
      width: 400px;
      padding-left: 20px;
      box-sizing: border-box;
      @media (max-width: 960px) {
        width: auto;
        padding: 0;
      }
      .detailRItem{
        padding: 20px 20px 10px;
        border-radius: 10px;
        border: #eee 1px solid;
        margin: 0 0 20px;
        h4{
          margin: 0 0 10px;
          font-size: 20px;
          font-weight: 600;
        }
        p{
          margin: 0 0 10px;
          font-size: 16px;
        }
        .tabCnt{
          display: flex;
          // align-items: center;
          border-bottom: #eee 1px solid;
          margin: -8px 0 14px;
          .tab{
            padding: 8px 0;
            box-sizing: border-box;
            font-size: 14px;
            font-weight: 500;
            position: relative;
            text-align: center;
            width: 50%;
            cursor: pointer;
            color: #767676;
            transition: all .3s ease;
            &:before{
              content: "";
              position: absolute;
              left: 0; right: 0; bottom: -1px;
              height: 3px;
              border-radius: 5px 5px 0 0;
              transition: all .3s ease;
            }
            &:hover{
              color: #555;
              &:before{
                background-color: #ccc;
              }
            }
            &.selected{
              color: #2c8c59;
              &:before{
                background-color: #369d66;
              }
            }
          }
        }
        .putusanItem{
          display: block;
          margin: 0 0 12px;
          padding: 10px;
          border-radius: 3px;
          box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
          border: #eee 1px solid;
          transition: all .3s ease;
          padding-right: 34px;
          position: relative;
          cursor: pointer;
          &:before{
            content: "";
            display: block;
            position: absolute;
            top: 12px; right: 10px;
            width: 16px; height: 16px;
            background-image: url(../assets/download-o.png);
            background-size: 16px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &.noDownload{
            cursor: default;
          }
          &.noDownload:before{
            display: none;
          }
          &:hover{
            background-color: #f5f5fe;
          }
          .type{
            color: #767676;
            font-size: 15px;
          }
          .putusanNo{
            font-weight: 600;
            font-size: 15px;
            color: #115457;
          }
        }
        .quotes{
          display: flex;
          .qt{
            margin: 0 14px 10px 0;
            color: #115457;
            cursor: pointer;
            &:hover{
              color: #369d66;
            }
          }
        }
        .footnote{
          font-size: 12px;
        }
        .copy{
          color: #115457;
          font-weight: 600;
          font-size: 14px;
          margin: -4px 0 5px;
          cursor: pointer;
          display: inline-block;
          padding-left: 22px;
          position: relative;
          &:before{
            content: "";
            position: absolute;
            left: 0; top: 0; bottom: 1px; width: 16px;
            background-image: url(../assets/copy-blue.png);
            background-size: 16px auto;
            background-position: left center;
            background-repeat: no-repeat;
            opacity: 1;
            transition: all .3s ease;
          }
          &:after{
            content: "";
            position: absolute;
            left: 0; top: 0; bottom: 1px; width: 16px;
            background-image: url(../assets/copy-blue-light.png);
            background-size: 16px auto;
            background-position: left center;
            background-repeat: no-repeat;
            opacity: 0;
            transition: all .3s ease;
          }
          &:hover{
            color: #369d66;
            &:before{
              opacity: 0;
            }
            &:after{
              opacity: 1;
            }
          }
        }
        .relatedItem{
          position: relative;
          padding: 6px 0;
          margin: 0 0 6px;
          padding-left: 30px;
          line-height: 1.4;
          display: block;
          .index{
            position: absolute;
            left: 0; top: 6px;
            color: #767676;
          }
          .relatedTitle{
            font-weight: 600;
            color: #115457;
            &:hover{
              color: #369d66;
            }
          }
        }
        .hakimOl{
          margin: 0;
          padding: 0;
          padding-left: 18px;
          li{
            padding-left: 6px;
            margin: 0 0 6px;
            font-weight: 400;
            font-size: 15px;
            span{
              color: #767676;
            }
          }
        }
      }
    }
  }
}

.preview{
  position: fixed;
  z-index: 991;
  left: 0; right: 0; bottom: 0;
  padding: 10px 0;
  text-align: center;
  background-color: yellow;
  color: #222;
}
.protected{
  padding: 200px 0;
  text-align: center;
  background-color: #f5f5f5;
  img{
    opacity: .8;
    margin-bottom: 20px;
    height: 84px;
    opacity: .75;
  }
  h4{
    margin: 0 0 2px;
  }
  p{
    color: #767676;
    margin: 0;
  }
  .inputCnt{
    margin-top: 16px;
    position: relative;
    display: inline-block;
    width: 300px;
    .privateIcon{
      position: absolute;
      left: 8px; top: 8px;
      width: 30px; height: 30px;
      background-image: url(../assets/private.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .3;
    }
    button{
      position: absolute;
      width: 40px; height: 40px;
      border: none;
      border-radius: 50%;
      right: 4px; top: 4px;
      transition: all .3s ease;
      background-image: url(../assets/arrow-right-bold.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      background-color: #fff;
      opacity: .6;
      &:hover{
        background-color: #eee;
        opacity: 1;
      }
    }
    input{
      border-radius: 5px;
      border: #ccc 1px solid;
      padding: 10px 20px;
      text-align: center;
      font-size: 20px;
      width: 100%;
      box-sizing: border-box;
    }
  }
}
.articleContent{
  &.html{
    // max-width: 1180px;
    // margin: 0 auto;
    overflow: hidden;
  }
  &.image{
    height: 640px;
    position: relative;
    background-color: #444;
    .theImg{
      position: absolute;
      left: 40px; top: 40px; right: 40px; bottom: 40px;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
  &.video{
    height: 640px;
    position: relative;
    background-color: #000;
    @media (max-width: 1200px) {
      height: 60vw;
    }
    &.youtube{
      iframe{
        width: 100%; height: 100%;
      }
    }
  }
  &.audio{
    border: #eee 1px solid;
    max-width: 1180px;
    margin: 0 auto;
    @media (max-width: 1300px) {
      max-width: 1140px;
    }
    @media (max-width: 1220px) {
      margin: 0 20px;
    }
    @media (max-width: 680px) {
      margin: 0 16px;
    }
  }
}
.sectionTitle{
  font-size: 32px;
  line-height: 1.3;
  margin: 0 auto 10px;
  max-width: 1180px;
  a{
    font-size: 17px;
    font-weight: 600;
    display: inline-block;
    border: #002f5f 1px solid;
    padding: 6px 10px 5px;
    border-radius: 2px;
    margin-top: 0px;
    float: right;
    transition: all .3s ease;
    &:hover{
      background-color: #002f5f;
      color: #fff;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    }
  }
  @media (max-width: 1300px) {
    max-width: 1140px;
  }
  @media (max-width: 1220px) {
    margin: 0 20px 10px;
  }
  @media (max-width: 680px) {
    margin: 0 16px 10px;
    font-size: 20px;
  }
}

.articleShare{
  position: absolute;
  top: 192px;
  left: calc(((100% - 750px) / 2) - 80px);
  padding: 12px 10px 5px;
  z-index: 9;
  background-color: #fff;
  border-radius: 5px;
  // font-family: 'Source Serif Pro', serif;
  @media (max-width: 960px) {
    margin-left: 20px;
  }
  &.articleShareStatic{
    position: static;
    padding: 0 0 6px;
    margin: -4px 0 0 -6px;
    .shareCnt{
      display: flex;
      a{
        margin-right: 10px;
      }
    }
  }
  h4{
    margin: 0 0 10px;
    font-size: 8px;
    text-align: center;
    text-transform: uppercase;
    color: #767676;
  }
  a{
    display: block;
    .fa{
      width: 40px;
      height: 40px;
      display: block;
      border-radius: 50%;
      margin: 0 auto;
      margin-top: 4px;
      background-size: 26px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .5;
      &:hover{
        background-color: #fff;
        opacity: 1;
      }
    }
    .fa.fa-facebook{
      background-image: url(../assets/share-facebook.png);
    }
    .fa.fa-twitter{
      background-image: url(../assets/share-twitter.png);
    }
    .fa.fa-whatsapp{
      background-image: url(../assets/share-whatsapp.png);
    }
    .fa.fa-telegram{
      background-image: url(../assets/share-telegram.png);
    }
    .fa.fa-email{
      background-image: url(../assets/share-email.png);
    }
  }
  @media (max-width: 974px) {
    position: static;
    display: flex;
    left: 0;
    top: auto;
    transform: none;
    bottom: 70px;
    border-radius: 0;
    flex-wrap: wrap;
    padding: 20px 0 0;
    h4{
      width: 50px;
      padding-top: 6px;
      width: 100%;
      text-align: left;
      margin-bottom: 6px;
      font-size: 17px;
      text-transform: none;
    }
    .shareCnt{
      display: flex;
      margin-left: -5px;
      a{
        margin: 0;
        margin-right: 10px;
        padding: 0;
        .fa{
          margin: 0;
        }
      }
    }
  }
}
</style>
